import router from '@/router'

// 跳转
export function routeTo(path, { query = {}, blank = false } = {}) {
  // reload
  if (path === 0) {
    router.go(0)
    // go back
  } else if (path === -1) {
    router.go(-1)
  } else {
    if (blank) {
      const route = router.resolve({
        path: path,
        query: query,
        params: query
      })
      window.open(route.href, '_blank')
    } else {
      router.push({
        path: path,
        query: query
      })
    }
  }
}

// 提取query obj
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

// 格式化金钱
export const formatMoney = str => str ? ('' + str).replace(/\B(?=(\d{3})+\b)/g, ',') : null

// 获取oss文件
export const joinFile = (path, download = false) => `https://oss-img.sunrate.com/webapp/samp/file/${path}${download ? '?response-content-type=application/octet-stream' : ''}`
/**
   * 掩码展示
   * @param value
   * @param type
   * @returns {string|*}
   */
export const maskText = (value, type) => {
  // 空字符串直接返回
  if (!value) {
    return
  }

  // 邮箱掩码：xxx****@yyy****
  if (type === 'email') {
    const splitArr = value.split('@')
    // 不是邮箱格式，直接返回
    if (splitArr.length < 2) {
      return value
    }

    return `${splitArr[0].slice(0, 3)}****@${splitArr[1].slice(0, 3)}****`
  }

  // 手机掩码： xxx****yyyy
  if (type === 'mobile') {
    const maskValue = '****'
    if (value.length > 7) {
      const first = value.substr(0, 3)
      const last = value.substr(value.length - 4)
      return first + maskValue + last
    }
  }

  // 在table中的简短掩码展示： xx****yy
  if (type === 'table') {
    const maskValue = '****';
    if (value.length < 5) {
      return maskValue;
    } else {
      let first = value.substr(0, 2);
      let last = value.substr(value.length - 2);
      return first + maskValue + last;
    }
  }

  // 在table中的简短掩码展示： ****yyyy
  if (type === 'table2') {
    const isIBAN = (str) => {
      const regex = /^[A-Za-z]{2}[^A-Za-z]/;
      return regex.test(str);
    }
    const maskValue = '****';
    if (isIBAN(value)) {
      if (value.length > 6) {
        let first = value.substr(0, 2);
        let last = value.substr(value.length - 4);
        return first + maskValue + last;
      }
    } else {
      if (value.length > 4) {
        let last = value.substr(value.length - 4);
        return maskValue + last;
      }
    }
    return value
  }

  // 其他通用情况：
  // 长度9及以上： xxxx ****** yyyy
  // 长度6-9： xx ***** yyy
  const maskValue = '*****'
  if (value.length >= 9) {
    const first = value.substr(0, 4)
    const last = value.substr(value.length - 4)
    return first + maskValue + last
  } else if (value.length < 9 && value.length >= 6) {
    const first = value.substr(0, 2)
    const last = value.substr(value.length - 3)
    return first + maskValue + last
  }

  return maskValue
}